import { render, staticRenderFns } from "./Campos.vue?vue&type=template&id=4e575a21&scoped=true"
import script from "./Campos.vue?vue&type=script&lang=js"
export * from "./Campos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e575a21",
  null
  
)

export default component.exports